import { render } from "./testMotion.vue?vue&type=template&id=db22bf10&scoped=true"
const script = {}

import "./testMotion.vue?vue&type=style&index=0&id=db22bf10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db22bf10"]])

export default __exports__